import CountrySelect from "../../../common/CountrySelector"
import React from "react"
import {
  TextField,
  Grid,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
} from "@mui/material"
import PropTypes from "prop-types"
import i18n from "i18n"
import TagField from "common/TagField"

const GeneralTab = ({
  fields,
  handleChange,
  handleCategoryChange,
  categoryOptions = [],
  onCreateTag,
  onDeleteTag,
  errors = {},
}) => {
  return (
    <Grid container spacing={2} sx={{ mt: 1 }}>
      <Grid item xs={3}>
        <FormControl fullWidth>
          <InputLabel>{i18n.t("contacts.type")}</InputLabel>
          <Select
            label={i18n.t("contacts.type")}
            name="type"
            value={fields.type}
            onChange={handleChange}
          >
            <MenuItem value="company">{i18n.t("contacts.company")}</MenuItem>
            <MenuItem value="individual">
              {i18n.t("contacts.individual")}
            </MenuItem>
            <MenuItem value="autonomous">
              {i18n.t("contacts.autonomous")}
            </MenuItem>
            <MenuItem value="publicAdmin">
              {i18n.t("contacts.publicAdmin")}
            </MenuItem>
          </Select>
        </FormControl>
      </Grid>
      <Grid item xs={3}>
        <TextField
          label={i18n.t("contacts.id")}
          name="id"
          value={fields.id || ""}
          onChange={handleChange}
          fullWidth
        />
      </Grid>
      <Grid item xs={3}>
        <TagField
          multiple={false}
          selectedTags={fields.category || []}
          onChange={handleCategoryChange}
          options={categoryOptions}
          onCreateTag={onCreateTag}
          onDeleteTag={onDeleteTag}
          label={i18n.t("contacts.category")}
        />
      </Grid>
      <Grid item xs={3}>
        <TextField
          label={`${i18n.t("contacts.companyName")} *`}
          name="companyName"
          value={fields.companyName}
          onChange={handleChange}
          fullWidth
          autoFocus
          disabled={fields.type === "individual"}
          error={!!errors.companyName}
        />
      </Grid>
      <Grid item xs={3}>
        <TextField
          label={i18n.t("contacts.fiscalIdType")}
          name="fiscalIdType"
          value={fields.fiscalIdType}
          onChange={handleChange}
          fullWidth
        />
      </Grid>
      <Grid item xs={3}>
        <TextField
          label={i18n.t("contacts.fiscalIdNumber")}
          name="fiscalIdNumber"
          value={fields.fiscalIdNumber}
          onChange={handleChange}
          fullWidth
        />
      </Grid>
      <Grid item xs={3}>
        <TextField
          label={i18n.t("contacts.cp")}
          name="cp"
          value={fields.cp}
          onChange={handleChange}
          fullWidth
        />
      </Grid>
      <Grid item xs={3}>
        <TextField
          label={i18n.t("contacts.street1")}
          name="street1"
          value={fields.street1}
          onChange={handleChange}
          fullWidth
        />
      </Grid>
      <Grid item xs={4}>
        <TextField
          label={i18n.t("contacts.street2")}
          name="street2"
          value={fields.street2}
          onChange={handleChange}
          fullWidth
        />
      </Grid>
      <Grid item xs={4}>
        <TextField
          label={i18n.t("contacts.city")}
          name="city"
          value={fields.city}
          onChange={handleChange}
          fullWidth
        />
      </Grid>
      <Grid item xs={4}>
        <TextField
          label={i18n.t("contacts.state")}
          name="state"
          value={fields.state}
          onChange={handleChange}
          fullWidth
        />
      </Grid>
      <Grid item xs={6}>
        <CountrySelect
          value={fields.country || null}
          onChange={(event, newValue) => {
            handleChange({
              target: {
                name: "country",
                value: newValue || "",
              },
            })
          }}
        />
      </Grid>
    </Grid>
  )
}

GeneralTab.propTypes = {
  fields: PropTypes.object.isRequired,
  handleChange: PropTypes.func.isRequired,
  handleCategoryChange: PropTypes.func.isRequired,
  categoryOptions: PropTypes.array,
  onCreateTag: PropTypes.func,
  onDeleteTag: PropTypes.func,
  errors: PropTypes.object,
}

GeneralTab.defaultProps = {
  categoryOptions: [],
  onCreateTag: () => {},
  onDeleteTag: () => {},
}

export default GeneralTab
